import { calculateCompoundedInterest } from '../../pool-math';
import { rayMul } from '../../ray.math';
export function calculateReserveDebt(reserveDebt, currentTimestamp) {
    const totalVariableDebt = getTotalVariableDebt(reserveDebt, currentTimestamp);
    const totalDebt = totalVariableDebt;
    const totalLiquidity = totalDebt.plus(reserveDebt.availableLiquidity);
    return {
        totalVariableDebt,
        totalDebt,
        totalLiquidity,
    };
}
function getTotalVariableDebt(reserveDebt, currentTimestamp) {
    return rayMul(rayMul(reserveDebt.totalScaledVariableDebt, reserveDebt.variableBorrowIndex), calculateCompoundedInterest({
        rate: reserveDebt.variableBorrowRate,
        currentTimestamp,
        lastUpdateTimestamp: reserveDebt.lastUpdateTimestamp,
    }));
}
//# sourceMappingURL=calculate-reserve-debt.js.map